import React from "react";
import { BsLinkedin } from "react-icons/bs";
import { FaGithub } from "react-icons/fa";

const HeaderSocials = () => {
  return (
    <div className="header__socials">
      {/* adding the rel attribute to the a elements with the value of "noreferrer noopener" 
      to avoid the security risk and adding content to the a elements for accessibility purposes */}
      <a href="https://www.linkedin.com/in/mahdichihi/" target="_blank" rel="noreferrer ">
        <BsLinkedin />
      </a>
      <a href="https://github.com/mahdichihi" target="_blank" rel="noreferrer ">
        <FaGithub />
      </a>
    </div>
  );
};

export default HeaderSocials;
